import React from 'react';
import type { ShowHideState } from '@splunk/dashboard-types';
import { ShowHideEye } from '../ShowHideEye';

export interface VisibilityButtonProps {
    visibilityState?: ShowHideState;
    onToggleVisibility?: (newVisibilityState: ShowHideState) => void;
}

export const VisibilityButton = ({
    visibilityState,
    onToggleVisibility,
}: VisibilityButtonProps) => {
    const hasVisibilityToggle = !!visibilityState && !!onToggleVisibility;

    if (!hasVisibilityToggle) {
        return null;
    }

    return (
        <ShowHideEye
            state={visibilityState}
            onToggleState={onToggleVisibility}
        />
    );
};
